'use strict';

exports.__esModule = true;
exports.default = {
  LIKE: 'like',
  RECOMMEND: 'recommend'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-facebook/lib/constants/LikeAction.js
// module id = 749
// module chunks = 0